/* @flow */
/* eslint-env es6,browser */

const DEBUG_KEY = '__jsapi_debugconsole';

/**
 * @description Helper to get cookie
 * @param {string} name - cookie key
 * @param {Document} doc - Document object
 * @returns {string} - cookie value
 */
function getCookie(
  name: string = '',
  doc?: Document = window.document
): string {
  let ret = '';
  if (name.length > 0 && doc.cookie) {
    const m =
      doc.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]*)\\s*(;|$)`) || [];
    if (m.length >= 3) {
      ret = decodeURIComponent(m[2]);
    }
  }
  return ret;
}

const debugConsole: boolean =
  document.location.href.includes(`${DEBUG_KEY}=1`) ||
  getCookie(DEBUG_KEY) === '1';

/**
 * Utility to check whether debugging is enabled/not.
 * Need to add '__jsapi_debugconsole=1' to the web page
 * URL query params
 *
 * @returns {boolean} - Debugging is enabled or not
 */
export default function isdebugEnabled(): boolean {
  return debugConsole;
}
